import { initActionGenre, setActionGenre } from '@modules/actionGenre';
import { useDispatch } from '@stores';
import { IStoreActionGenre } from '@types';
import { useCallback } from 'react';

const useActionGenreActions = () => {
  const dispatch = useDispatch();

  const onInitActionGenre = useCallback(() => {
    dispatch(initActionGenre());
  }, [dispatch]);

  const onSetActionGenre = useCallback(
    (payload: Partial<IStoreActionGenre>) => {
      dispatch(setActionGenre(payload));
    },
    [dispatch]
  );

  return { onInitActionGenre, onSetActionGenre };
};

export default useActionGenreActions;
